export const resourceLinks = [
  { slug: 'campanhas-personalizadas', title: 'Campanhas personalizadas' },
  { slug: 'painel-de-gestao', title: 'Painel de gestão' },
  { slug: 'pagamentos', title: 'Pagamentos integrados' },
  { slug: 'roleta-da-sorte', title: 'Roleta da sorte' },
  { slug: 'afiliados', title: 'Programa de afiliados' },
  { slug: 'rastreamento-de-anuncios', title: 'Rastreamento de anúncios' },
  { slug: 'resultados-e-ganhadores', title: 'Resultados e ganhadores' },
] as const
